import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import { NO_BOOKING_SUGGESTION, type BookingSuggestion } from '../types';

type ServiceUserEnvelope<T> = {
  message?: string;
  status?: string;
  responseBody?: T;
  errorCode?: number;
  errorMessage?: string | null;
};

// Only pre-fills the reason picker: any failure means "no suggestion" and
// the form keeps its default, so this never blocks booking.
export const getParentConnectBookingSuggestion = async (
  variantId: string
): Promise<BookingSuggestion> => {
  try {
    const data: ServiceUserEnvelope<BookingSuggestion> = await axios.get(
      '/user/v1/trainer-slots/parent-connect/booking-suggestion',
      { params: { variant_id: variantId } }
    );
    return { ...NO_BOOKING_SUGGESTION, ...data?.responseBody };
  } catch {
    return NO_BOOKING_SUGGESTION;
  }
};

export const getParentConnectBookingSuggestionMockHandler = http.get(
  `${env.API_URL}/user/v1/trainer-slots/parent-connect/booking-suggestion`,
  async () => {
    await networkDelay();
    return HttpResponse.json<ServiceUserEnvelope<BookingSuggestion>>({
      status: 'SUCCESS',
      message: 'Parent connect booking suggestion fetched',
      errorCode: 0,
      errorMessage: null,
      responseBody: NO_BOOKING_SUGGESTION,
    });
  }
);
